// Lify.Common.Helpers.SensitiveDataRedactor, rule for rule: what a log shipped to the server must not carry -
// emails, phone numbers, and the values of credential fields in JSON, forms and query strings.

const MASK = '[REDACTED]';

const JSON_FIELD = new RegExp(
    '("(?:password|pass|pwd|newPassword|oldPassword|currentPassword|confirmPassword|secret|'
    + 'clientSecret|token|access_token|refresh_token|id_token|accessToken|refreshToken|idToken|'
    + 'code|otp|pin|verificationCode|tempToken|apiKey|api_key|authorization)"\\s*:\\s*)'
    + '("[^"]*"|\\d+)',
    'gi'
);

const FORM_FIELD = new RegExp(
    '(password|pwd|pass|secret|client_secret|token|access_token|refresh_token|id_token|code|otp|'
    + 'pin|verificationcode|temptoken|apikey|api_key|authorization)=([^&\\s]*)',
    'gi'
);

const EMAIL = /[A-Za-z0-9._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}/g;

const PHONE = /(?<!\d)\+?\d(?:[\d\-\s().]{6,})\d(?!\d)/g;

export function redact(value: string | null | undefined): string {
    if (!value) return value ?? '';

    return String(value)
        .replace(JSON_FIELD, (_match: string, key: string) => `${key}"${MASK}"`)
        .replace(FORM_FIELD, (_match: string, key: string) => `${key}=${MASK}`)
        .replace(EMAIL, '[REDACTED_EMAIL]')
        .replace(PHONE, '[REDACTED_PHONE]');
}
